import React, { Component } from 'react'
import './switchhorizontal.scss'

class SwitchHorizontal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isChecked: Boolean(props.isChecked) || '',
			type: props.type ? props.type : 'radio',
			idFirst: props.idFirst ? props.idFirst : '',
			idSecond: props.idSecond ? props.idSecond : '',
			for: props.for ? props.for : '',
			name: props.name ? props.name : 'name',
			labelFirst: props.labelFirst ? props.labelFirst : '',
			labelSecond: props.labelSecond ? props.labelSecond : '',
			state: props.state ? props.state : '',
			value: props.value ? props.value : '',
			labelClasses: props.labelClasses ? props.labelClasses : '',
			classes: props.classes ? props.classes : '',
			onChange: props.onChange ? props.onChange : this.handleChange
		}
	}

	handleChange = () => {
		this.setState({ isChecked: !this.state.isChecked })
	}

	handleOptionChange = (event) => {
		this.setState({
			value: event.target.value
		})
		this.props.optionSelected(this.state.value)
	}

	render() {
		const classes = ['vbui--input', this.state.classes, this.state.state].join(' ')
		const labelClass = ['group vbui--toggle-h-switch-container', this.state.labelClasses, this.state.showIcon].join(' ')
		return (
			<div className={labelClass}>
				<div className="toggle-switch switch-horizontal">
					<input
						id={this.state.idFirst}
						type={this.state.type}
						className={classes}
						name={this.state.name}
						checked={this.state.idFirst === this.state.value}
						onChange={this.handleOptionChange}
						value={this.state.idFirst}
					/>
					<label htmlFor={this.state.idFirst}>{this.state.labelFirst}</label>
					<span className="toggle-outside">
						<span className="toggle-inside"></span>
					</span>
					<input
						id={this.state.idSecond}
						type={this.state.type}
						className={classes}
						name={this.state.name}
						checked={this.state.idSecond === this.state.value}
						onChange={this.handleOptionChange}
						value={this.state.idSecond}
					/>
					<label htmlFor={this.state.idSecond}>{this.state.labelSecond}</label>
				</div>
			</div>
		)
	}
}

export default SwitchHorizontal
